module.exports = __webpack_public_path__ + "assets/img/back.01e53c78.png";